/*
  Author: Vinod
  Date: 09/04/2020
  Issue Description: spelling mistake of Cost centre.
  Issue Id: PL_3049
 */

<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <!-- fnf format -->
    <div class="label">Select Format</div>
    <br />
    <div class="col-7">
      <div class="row" :disabled="!(ifTeamleaderPermission)">
        <div>
          <tl-radio
            name="formatalign"
            id="formatleftalign"
            value="left"
            v-model="fnfPayslipModel.format"
          />
          <img class="align-img" src="@/assets/fnfSlipFormat1.png" />
        </div>
        <div>
          <tl-radio
            name="formatalign"
            id="formatcentrealign"
            value="centre"
            v-model="fnfPayslipModel.format"
          />
          <img class="align-img" src="@/assets/fnfSlipFormat2.png" />
        </div>
        <div>
          <tl-radio
            name="formatalign"
            id="formatrightalign"
            value="right"
            v-model="fnfPayslipModel.format"
          />
          <img class="align-img" src="@/assets/fnfSlipFormat3.png" />
        </div>
      </div>
    </div>
    <br />
    <br />
    <!-- accordion header-->
    <tl-accordion headerName="Payslip Header" :active="true">
      <template v-slot:accordionBody>
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <tl-checkbox
              class="headcheck"
              label="Copy Format From - Monthly Payslip"
              v-model="fnfPayslipModel.copy_format"
              @change="(val)=>changeCopyFormatMPSCheckbox(val)"
            />
          </div>
          <br />
        </div>
        <br />
        <div v-if="!fnfPayslipModel.copy_format" :disabled="!(ifTeamleaderPermission)">
          <!-- company logo -->
          <div class="row">
            <div class="col-12">
              <tl-checkbox
                class="headcheck"
                label="Company Logo"
                v-model="fnfPayslipModel.company_logo"
              />
              <div class="imgCard">
                <img v-bind:src="leData.url" />
              </div>
            </div>

            <!-- align section -->
            <div class="col-7 section-details">
              <div class="row margintop-10">
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgleftalign"
                    label="Left align"
                    value="left"
                    :disabled="!fnfPayslipModel.company_logo"
                    v-model="fnfPayslipModel.logo_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgcentrealign"
                    label="Centre align"
                    value="centre"
                    :disabled="!fnfPayslipModel.company_logo"
                    v-model="fnfPayslipModel.logo_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgrightalign"
                    label="Right align"
                    value="right"
                    :disabled="!fnfPayslipModel.company_logo"
                    v-model="fnfPayslipModel.logo_alignment"
                  />
                </div>
              </div>
            </div>
            <!-- align section -->
          </div>
          <!-- company logo -->

          <!-- company name -->
          <div class="row margintop-20">
            <div class="col-12">
              <tl-checkbox
                class="headcheck"
                label="Company Name"
                v-model="fnfPayslipModel.company_name"
              />
            </div>
            <div class="col-12 section-details">
              <txt type="text" name="company_name" :disabled="true" v-model="leData.name" />
            </div>
            <!-- align section -->
            <div class="col-7 section-details">
              <div class="row">
                <div>
                  <tl-radio
                    name="namealign"
                    id="nameleftalign"
                    label="Left align"
                    value="left"
                    :disabled="!fnfPayslipModel.company_name"
                    v-model="fnfPayslipModel.company_name_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="namealign"
                    id="namecenteralign"
                    label="Centre align"
                    value="centre"
                    :disabled="!fnfPayslipModel.company_name"
                    v-model="fnfPayslipModel.company_name_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="namealign"
                    id="namerightalign"
                    label="Right align"
                    value="right"
                    :disabled="!fnfPayslipModel.company_name"
                    v-model="fnfPayslipModel.company_name_alignment"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- align section -->
          <!-- company name -->

          <!-- Address -->
          <div class="row margintop-20">
            <div class="col-12">
              <div class="heading">Address</div>
            </div>
            <div class="alignClass">
              <tl-radio
                name="le_address"
                id="fnfleaddress"
                label="Legal Entity Registered Address"
                value="LEGALADDR"
                v-model="comp_address"
              />
            </div>
            <div class="alignClass">
              <tl-radio
                name="loc_address"
                id="fnflocaddress"
                label="Location Address"
                value="LOCATIONADDR"
                v-model="comp_address"
              />
            </div>
          </div>
          <!-- Address -->

          <!-- date format -->
          <div class="row">
            <div class="col-12 margin-t-l">
              <tl-checkbox
                class="headcheck"
                label="Month &amp; Financial Year "
                v-model="fnfPayslipModel.month_year"
              />
            </div>
            <!-- Format -->
            <div class="col-7 section-details">
              <div class="row">
                <div class="col-3">
                  <tl-radio
                    name="monthFormat"
                    id="fnffullmonth"
                    label="MMM/YYYY"
                    value="mmmyyyy"
                    :disabled="!fnfPayslipModel.month_year"
                    v-model="fnfPayslipModel.month_year_format"
                  />
                </div>
                <div class="col-3">
                  <tl-radio
                    name="monthFormat"
                    id="fnfmonth"
                    label="MM/YYYY"
                    value="mmyyyy"
                    :disabled="!fnfPayslipModel.month_year"
                    v-model="fnfPayslipModel.month_year_format"
                  />
                </div>
              </div>
            </div>
            <!-- Format -->
          </div>
          <!-- date format -->
        </div>
        <!-- company logo -->
        <div v-if="fnfPayslipModel.copy_format" :disabled="!(ifTeamleaderPermission)">
          <div class="row">
            <div class="col-12">
              <tl-checkbox
                class="headcheck"
                label="Company Logo"
                v-model="monthlyPayslipModel.company_logo"
              />
              <div class="imgCard">
                <img v-bind:src="leData.url" />
              </div>
            </div>

            <!-- align section -->
            <div class="col-7 section-details">
              <div class="row margintop-10">
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgleftalign"
                    label="Left align"
                    value="left"
                    :disabled="!monthlyPayslipModel.company_logo"
                    v-model="monthlyPayslipModel.logo_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgcentrealign"
                    label="Centre align"
                    value="centre"
                    :disabled="!monthlyPayslipModel.company_logo"
                    v-model="monthlyPayslipModel.logo_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="logoalign"
                    id="lgrightalign"
                    label="Right align"
                    value="right"
                    :disabled="!monthlyPayslipModel.company_logo"
                    v-model="monthlyPayslipModel.logo_alignment"
                  />
                </div>
              </div>
            </div>
            <!-- align section -->
          </div>
          <!-- company logo -->

          <!-- company name -->
          <div class="row margintop-20">
            <div class="col-12">
              <tl-checkbox
                class="headcheck"
                label="Company Name"
                v-model="monthlyPayslipModel.company_name"
              />
            </div>
            <div class="col-12 section-details">
              <txt
                type="text"
                placeholder
                name="company_name"
                :disabled="true"
                v-model="orgData.name"
              />
            </div>
            <!-- align section -->
            <div class="col-7 section-details">
              <div class="row">
                <div>
                  <tl-radio
                    name="namealign"
                    id="nameleftalign"
                    label="Left align"
                    value="left"
                    :disabled="!monthlyPayslipModel.company_name"
                    v-model="monthlyPayslipModel.company_name_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="namealign"
                    id="namecenteralign"
                    label="Centre align"
                    value="centre"
                    :disabled="!monthlyPayslipModel.company_name"
                    v-model="monthlyPayslipModel.company_name_alignment"
                  />
                </div>
                <div>
                  <tl-radio
                    name="namealign"
                    id="namerightalign"
                    label="Right align"
                    value="right"
                    :disabled="!monthlyPayslipModel.company_name"
                    v-model="monthlyPayslipModel.company_name_alignment"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- align section -->
          <!-- company name -->

          <!-- Address -->
          <div class="row margintop-20">
            <div class="col-12">
              <div class="heading">Address</div>
            </div>
            <div class="alignClass">
              <tl-radio
                name="le_address"
                id="fnfleaddress"
                label="Legal Entity Registered Address"
                value="leaddress"
                v-model="monthlyPayslipModel.comp_address"
              />
            </div>
            <div class="alignClass">
              <tl-radio
                name="loc_address"
                id="fnflocaddress"
                label="Location Address"
                value="locaddress"
                v-model="monthlyPayslipModel.comp_address"
              />
            </div>
          </div>
          <!-- Address -->

          <!-- date format -->
          <div class="row">
            <div class="col-12 margin-t-l">
              <tl-checkbox
                class="headcheck"
                label="Month &amp; Financial Year "
                v-model="monthlyPayslipModel.month_year"
              />
            </div>
            <!-- Format -->
            <div class="col-7 section-details">
              <div class="row">
                <div class="col-3">
                  <tl-radio
                    name="monthFormat"
                    id="fnffullmonth"
                    label="MMM/YYYY"
                    value="mmmyyyy"
                    :disabled="!monthlyPayslipModel.month_year"
                    v-model="monthlyPayslipModel.month_year_format"
                  />
                </div>
                <div class="col-3">
                  <tl-radio
                    name="monthFormat"
                    id="fnfmonth"
                    label="MM/YYYY"
                    value="mmyyyy"
                    :disabled="!monthlyPayslipModel.month_year"
                    v-model="monthlyPayslipModel.month_year_format"
                  />
                </div>
              </div>
            </div>
            <!-- Format -->
          </div>
          <!-- date format -->
        </div>
        <!-- Custom Header Message -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="label-text margin-b-s margin-t-l">Customise Header Message</div>
            <textarea
              class="form-control width-100"
              label="Customise Header Message"
              name="calculation"
              v-model="fnfPayslipModel.header_message"
            />
          </div>
        </div>
        <!-- Custom Header Message Ends -->
      </template>
    </tl-accordion>

    <!-- action section -->

    <!-- accordion body-->
    <tl-accordion headerName="Payslip Body Content">
      <template v-slot:accordionBody>
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div
              class="below-text"
            >Below are the selected employee fields you want to show in Payslip.</div>
          </div>
        </div>
        <!-- Employee Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Employee Info</div>
            <div class="twoColumnGrid new-width-twoColumnGrid">
              <tl-checkbox
                class="headcheck"
                label="Employee Name"
                v-model="fnfPayslipModel.employee_name"
              />
              <tl-checkbox
                class="headcheck"
                label="Official Mail ID"
                v-model="fnfPayslipModel.official_mail"
              />
              <tl-checkbox
                class="headcheck"
                label="Employee Code "
                v-model="fnfPayslipModel.employee_code"
              />
              <tl-checkbox
                class="headcheck"
                label="Personal Mail ID"
                v-model="fnfPayslipModel.personal_mail"
              />
              <tl-checkbox
                class="headcheck"
                label="Date joined"
                v-model="fnfPayslipModel.date_joined"
              />
              <tl-checkbox class="headcheck" label="Date of Birth" v-model="fnfPayslipModel.dob" />
              <!-- PL_3049 -->
              <tl-checkbox
                class="headcheck"
                label="Cost Centre"
                v-model="fnfPayslipModel.cost_centre"
              />
              <tl-checkbox
                class="headcheck"
                label="Phone no."
                v-model="fnfPayslipModel.phone_number"
              />
              <tl-checkbox
                class="headcheck"
                label="Designation"
                v-model="fnfPayslipModel.designation"
              />
              <tl-checkbox
                class="headcheck"
                label="Permanent Address"
                v-model="fnfPayslipModel.permanent_address"
              />
              <tl-checkbox
                class="headcheck"
                label="Total no. of paid days"
                v-model="fnfPayslipModel.total_number_of_paid_days"
              />
              <tl-checkbox
                class="headcheck"
                label="Emergency contact no."
                v-model="fnfPayslipModel.emergency_contact_number"
              />
              <tl-checkbox
                class="headcheck"
                label="No. of LOPs"
                v-model="fnfPayslipModel.no_of_lop"
              />
              <tl-checkbox
                class="headcheck"
                label="PAN card no."
                v-model="fnfPayslipModel.pan_number"
              />
              <tl-checkbox
                class="headcheck"
                label="No. of RLOPs"
                v-model="fnfPayslipModel.no_of_rlop"
              />
              <tl-checkbox
                class="headcheck"
                label="Aadhar no."
                v-model="fnfPayslipModel.aadhar_number"
              />
              <tl-checkbox class="headcheck" label="UAN No." v-model="fnfPayslipModel.uan_number" />
            </div>
          </div>
        </div>
        <!-- Bank Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Bank Info</div>
            <div class="singleColumnGrid">
              <tl-checkbox
                class="headcheck"
                label="Payment Mode"
                v-model="fnfPayslipModel.payment_mode"
              />
              <tl-checkbox class="headcheck" label="Bank Name" v-model="fnfPayslipModel.bank_name" />
              <tl-checkbox
                class="headcheck"
                label="Bank Account Number"
                v-model="fnfPayslipModel.bank_account_number"
              />
              <tl-checkbox class="headcheck" label="IFSC Code" v-model="fnfPayslipModel.ifsc_code" />
            </div>
          </div>
        </div>
        <!-- Format for Payslip -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Format for Payslip</div>
            <div class="row margintop-10">
              <div class="col-2" v-for="(format, index) of payslipFormatList" :key="index">
                <tl-radio
                  name="payslipFormatTypefnf"
                  :id="'payslipFormatfnf'+index"
                  :label="format.name"
                  :value="format.id"
                  v-model="fnfPayslipModel.payslip_format_id"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Component -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Component</div>
            <div class="twoColumnGrid new-width-twoColumnGrid">
              <tl-checkbox
                class="headcheck"
                label="FBP components"
                v-model="fnfPayslipModel.fbp_component"
              />
              <tl-checkbox class="headcheck" label="IT Sheet" v-model="fnfPayslipModel.it_sheet" />
            </div>
          </div>
        </div>

        <!-- Other Info -->
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="payslip-label">Other Info</div>
            <div class="singleColumnGrid">
              <tl-checkbox
                class="headcheck"
                label="Loan Details"
                v-model="fnfPayslipModel.loan_details"
              />
              <tl-checkbox
                class="headcheck"
                label="Leave Details"
                v-model="fnfPayslipModel.leave_details"
              />
              <tl-checkbox
                class="headcheck"
                label="Leave Balances"
                v-model="fnfPayslipModel.leave_balances"
              />
              <tl-checkbox
                class="headcheck"
                label="Arrear Days"
                v-model="fnfPayslipModel.arrear_days"
              />
              <tl-checkbox
                class="headcheck"
                label="Release FnF Payslips based on date of relieving"
                v-model="fnfPayslipModel.release_fnf"
              />

              <!-- <tl-checkbox class="headcheck" label="Password"/> -->
            </div>

            <!-- <tl-checkbox class="headcheck" label="Password"/> -->
          </div>
        </div>
      </template>
    </tl-accordion>

    <!-- accordion body-->
    <tl-accordion headerName="Payslip Footer">
      <template v-slot:accordionBody>
        <div class="row" :disabled="!(ifTeamleaderPermission)">
          <div class="col-12">
            <div class="label-text margin-b-s">Customise Footer Message</div>
            <textarea
              class="form-control width-100"
              label="Customise Footer Message"
              name="calculation"
              v-model="fnfPayslipModel.footer_message"
            />
          </div>
        </div>
      </template>
    </tl-accordion>

    <div class="row margin-t-m" v-if="!isFromPaygroup">
       <div class="col-12 centering">
        <button class="btn primaryBtn" type="primary" @click="previewPayslip">Preview Payslip</button>
       </div>
    </div>

    <!-- action section -->

    <!-- preview modal -->
    <div class="modal custom-modal" v-if="showPreviewModal">
      <div class="modal-content modal-md">
        <div class="modal-header">
          <div class="row">
            <div class="col-6">
              <h3>Payslip Preview</h3>
            </div>
            <div class="col-6 align-right">
              <a href="javascript:void(0)" class="close-btn" @click="previewPayslipCancel">Close</a>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <!-- select-section -->
          <iframe
            id="payslip"
            v-if="previewPayslipUrl"
            :src="previewPayslipUrl"
            style="width:100%; height:450px;"
            frameborder="0"
          />
          <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Close" type="secondary" @click="previewPayslipCancel" />
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
    <!-- preview modal -->
    <div class="button-group">
      <bottom-action-container>
        <btn-skip @navClicked="skip" v-if="!isFromPaygroup"></btn-skip>
        <template slot="end">
          <btn-grp v-if="!isFromPaygroup">
            <btn text="Previous" type="secondary" @click="$emit('stepNum',4)" />
            <btn text="Next" type="primary" @click="createPayslip" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
          </btn-grp>
          <btn-grp v-if="isFromPaygroup">
            <btn text="Cancel" type="secondary" @click="$emit('goBackToPaygroup', {})"></btn>
            <btn text="Save" type="primary" @click="savePaygroupfnf"></btn>
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Payslips",
  props: {
    isFromPaygroup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPreviewModal: false,
      showAccordionBody: false,
      previewPayslipUrl: "",
      isCompanyLogo: false,
      company_address: "true",
      payslipFormatList: [],
      comp_address: "LEGALADDR",
      fnfPayslipModel: {
        org_id: "",
        copy_format: false,
        le_id: "",
        name: "",
        header_message: "",
        comp_address: "LEGALADDR",
        company_logo: false,
        logo_alignment: "",
        company_name: null,
        company_name_alignment: "",
        format: "left",
        company_address: true,
        month_year: true,
        month_year_format: "mmyyyy",
        employee_name: true,
        employee_code: true,
        date_joined: true,
        cost_centre: false,
        designation: true,
        total_number_of_paid_days: true,
        no_of_lop: true,
        no_of_rlop: true,
        uan_number: true,
        official_mail: true,
        personal_mail: true,
        dob: false,
        phone_number: true,
        permanent_address: true,
        emergency_contact_number: false,
        pan_number: true,
        aadhar_number: true,
        bank_name: true,
        bank_account_number: true,
        payment_mode: true,
        ifsc_code: true,
        payslip_format_id: null,
        fbp_component: true,
        it_sheet: true,
        loan_details: true,
        leave_details: true,
        leave_balances: true,
        arrear_days: true,
        release_fnf: true,
        default: true,
        criteria_id: "",
        footer_message: "",
        payslip_criteria: "LEGAL_ENTITY"
      },
      monthlyPayslipModel: {
        org_id: "",
        copy_format: false,
        le_id: "",
        name: "",
        header_message: "",
        comp_address: "LEGALADDR",
        company_logo: false,
        logo_alignment: "",
        company_name: null,
        company_name_alignment: "",
        format: "",
        company_address: true,
        month_year: true,
        month_year_format: "mmyyyy",
        employee_name: true,
        employee_code: true,
        date_joined: true,
        cost_centre: false,
        designation: true,
        total_number_of_paid_days: true,
        no_of_lop: true,
        no_of_rlop: true,
        uan_number: true,
        official_mail: true,
        personal_mail: true,
        dob: false,
        phone_number: true,
        permanent_address: true,
        emergency_contact_number: false,
        pan_number: true,
        aadhar_number: true,
        bank_name: true,
        bank_account_number: true,
        payment_mode: true,
        ifsc_code: true,
        payslip_format_id: null,
        fbp_component: true,
        it_sheet: true,
        loan_details: true,
        leave_details: true,
        leave_balances: true,
        arrear_days: true,
        release_fnf: true,
        default: true,
        criteria_id: "",
        footer_message: "",
        payslip_criteria: "LEGAL_ENTITY"
      },
      legalEntityList: [],
      leData: {
        name: "",
        url: ""
      },
      payrollPreferencesValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({
      globalData: state => state.globalapi.globalData.data
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
      orgData: state => state.data[0]
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    footerHeaderName() {
      this.setGlobalData();
      this.getPayslipData();
      return "Payslip Footer name";
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.payrollPreferencesValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.payrollPreferencesValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  activated() {
    this.setGlobalData();
    this.getLegalEntityList();
    this.getPayslipData();
    this.getOrgLeIdList();
  },
  mounted() {
    this.setGlobalData();
    this.getLegalEntityList();
    this.getPayslipData();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      create_payslip: "onboard/settings/fnfpayslip/create",
      update_payslip: "onboard/settings/fnfpayslip/update",
      fetch_payslip: "onboard/settings/fnfpayslip/fetchAll",
      previw_payslip: "onboard/settings/payslip/payslipPreview",
      fetch_monthly_payslip: "onboard/settings/payslip/fetchAll",
      act_fetch_legalEntitiesList: "onboard/legal_entities/fetchAll"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* function to copy the payslip data from monthly payslip data */
    changeCopyFormatMPSCheckbox(val) {
      try {
        if (this.fnfPayslipModel.copy_format) {
          if (this.monthlyPayslipModel.company_logo) {
            this.monthlyPayslipModel.logo_alignment = "left";
          } else {
            this.monthlyPayslipModel.logo_alignment = "";
          }
        } else {
          if (this.fnfPayslipModel.company_logo) {
            this.fnfPayslipModel.logo_alignment = "left";
          } else {
            this.fnfPayslipModel.logo_alignment = "";
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to save pay group FnF payslip for custom pay group */
    savePaygroupfnf() {
      this.$emit("goBackToPaygroup", this.fnfPayslipModel);
    },

    /* server call to get LE */
    async getLegalEntityList() {
      try {
        let res = await this.act_fetch_legalEntitiesList(this.orgId);

        if (res.status == 200) {
          this.legalEntityList = res.data.payload.data;
        }
        for (var i = 0; i < this.legalEntityList.length; i++) {
          if (this.legalEntityList[i].id == this.leId) {
            this.leData.name = this.legalEntityList[i].legalName;
            this.leData.url = this.legalEntityList[i].logoURL;
            break;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set default values */
    setGlobalData() {
      try {
        this.payslipFormatList = this.globalData
          ? this.globalData.PayslipFormat
            ? this.globalData.PayslipFormat
            : []
          : [];
        if (!this.fnfPayslipModel.id) {
          this.fnfPayslipModel.payslip_format_id = this.payslipFormatList[0].id;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* server call to get monthly payslip data */
    async getPayslipData() {
      try {
        let res = await this.fetch_monthly_payslip(this.leId);
        if (res.data.status && res.data.payload) {
          let Obj = res.data.payload;
          if (Obj) {
            this.showPreviewButton = true;
            if (Obj.company_address) {
              this.company_address = "LEGALADDR";
            } else {
              this.company_address = "LOCATIONADDR";
            }
            this.monthlyPayslipModel = Obj;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* server call to submit the FnF payslip data */
    async createPayslip() {
      try {
        if(this.ifAnchor) {
          this.nextPage();
        } else {
        this.fnfPayslipModel.criteria_id = this.leId;
        this.fnfPayslipModel.payslip_criteria = "LEGAL_ENTITY";
        this.fnfPayslipModel.org_id = this.orgId;
        this.fnfPayslipModel.le_id = this.leId;
        if (this.comp_address == "LEGALADDR") {
          this.fnfPayslipModel.company_address = true;
        } else {
          this.fnfPayslipModel.company_address = false;
        }

        let res = {};
        res = await this.create_payslip({
          data: {
            ...this.fnfPayslipModel
          }
        });
        if (res.data.status) {
          this.$router.push(
            `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
          );
        }
       }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get FnF payslip data */
    async getPayslipData() {
      try {
        let res = await this.fetch_payslip(this.leId);
        if (res.data.status && res.data.payload) {
          let Obj = res.data.payload;
          if (Obj) {
            this.fnfPayslipModel = Obj;
            if (Obj.company_address) {
              this.comp_address = "LEGALADDR";
            } else {
              this.comp_address = "LOCATIONADDR";
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to toggle the accordion */
    toggleContent() {
      this.showAccordionBody = !this.showAccordionBody;
    },

    /* function to skip the step and go to next page pay group */
    skip() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/ctcSlab`
      );
    },

    /* function to cancel the preview and hide the modal */
    previewPayslipCancel() {
      this.showPreviewModal = false;
    },

    /* server call to get payslip data for preview as PDF */
    async previewPayslip() {
      try {
        let res = await this.previw_payslip(this.leId);
        let myBlob = new Blob([res.data], { type: "application/pdf" });
        let myReader = new FileReader();
        myReader.onloadend = e => {
          this.previewPayslipUrl = myReader.result;
        };
        myReader.readAsDataURL(myBlob);
        if (res.status == 200) {
          this.showPreviewModal = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      );
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.label {
  font-size: 14px;
  color: #404040;
}
.primaryBtn {
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  display: inline-block;
}
.centering{
  text-align: center;
}
.payslip-label {
  font-size: 16px;
  font-weight: 600;
  font-family: Montserrat;
  color: rgb(26, 25, 25);
  margin-top: 24px;
  margin-bottom: 24px;
}
.button-group {
  margin-left: -16px;
}
.alignClass {
  margin-top: 10px;
}
.address-label {
  font-size: 14px;
  font-weight: 500;
  font-family: Montserrat;
  color: rgb(26, 25, 25);
  margin-top: 24px;
}
.new-width-twoColumnGrid {
  grid-template-columns: 25% 25%;
}
.inner-container {
  height: auto;
  overflow: hidden;
}
.align-img {
  margin-left: 20px;
  margin-top: -5px;
  margin-right: 30px;
}
.imgCard img {
  width: 60px;
  margin-left: 30px;
  margin-top: 10px;
  height: 60px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
